import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styles from "./Onboarding3New.module.css";
import questionmarkIcon from "../../Images/questionmark.svg";
import PopUpEligibility from "../../Components/PopUpEligibility";
import TopNavBarNew from "../../Components/TopNavBarNew";
import BottomNavBarNew from "../../Components/BottomNavBarNew";

export default function Onboarding3New({ appLanguage }) {
  const [pageState, setPageState] = useState({
    stepNumber: "",
    title: "",
    title2: "",
    options: [],
    buttonText: "",
  });
  const [selectedChoices, setSelectedChoices] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupContent, setPopupContent] = useState({
    icon: "",
    title: "",
    paragraph: "",
    buttonText: "OK",
  });

  const localStorageKey = "userSelectedOptions";
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Eligibility Quiz";

    const entries = JSON.parse(localStorage.getItem("ayaAppEntries") || "[]");

    const getEntryById = (id) => entries.find((entry) => entry.sys.id === id);
    const getField = (entry, field, locale) =>
      entry?.fields?.[field]?.[locale] || entry?.fields?.[field]?.["en"] || "";

    const abortionFlowEntry = getEntryById("23ufQUIe9b38qdpKK4RUEY");

    setPageState({
      stepNumber: getField(abortionFlowEntry, "stepNumber", appLanguage),
      title: getField(abortionFlowEntry, "title", appLanguage),
      title2: getField(abortionFlowEntry, "title2", appLanguage),
      options: [
        getField(abortionFlowEntry, "optionText1", appLanguage),
        getField(abortionFlowEntry, "optionText2", appLanguage),
        getField(abortionFlowEntry, "optionText3", appLanguage),
        getField(abortionFlowEntry, "optionText4", appLanguage),
        getField(abortionFlowEntry, "optionText5", appLanguage),
      ],
      buttonText: getField(abortionFlowEntry, "buttonText", appLanguage),
    });

    // Restore previously selected choices for Onboarding3New if user comes back
    const savedOptions = JSON.parse(localStorage.getItem(localStorageKey)) || [];
    const currentPageSelections = savedOptions.filter(
      (choice) => choice.page === "Onboarding3New"
    );

    if (currentPageSelections.length > 0) {
      setSelectedChoices(
        currentPageSelections.map((choice) =>
          parseInt(choice.option.replace("option", "")) - 1
        )
      );
    } else {
      setSelectedChoices([]);
    }
  }, [appLanguage]);

  const handleChoiceClick = (index) => {
    const lastOptionIndex = pageState.options.length - 1;

    // If user picks the last option, remove any others
    if (index === lastOptionIndex) {
      setSelectedChoices([index]);
    } else {
      // If last option was selected earlier, remove it
      if (selectedChoices.includes(lastOptionIndex)) {
        setSelectedChoices([index]);
      } else {
        // Toggle the clicked option
        setSelectedChoices((prev) =>
          prev.includes(index)
            ? prev.filter((choice) => choice !== index)
            : [...prev, index]
        );
      }
    }
  };

  const handleContinue = () => {
    const savedData = JSON.parse(localStorage.getItem(localStorageKey)) || [];

    // Before, you filtered out the last option. Now we store everything.
    const currentPageData = selectedChoices.map((choice) => ({
      page: "Onboarding3New",
      option: `option${choice + 1}`,
      optionText: pageState.options[choice], // <-- store the text
      isLastOption: choice === pageState.options.length - 1, // <-- flag last option
    }));

    // Remove old Onboarding3New data, then add new
    const updatedData = [
      ...savedData.filter((data) => data.page !== "Onboarding3New"),
      ...currentPageData,
    ];

    localStorage.setItem(localStorageKey, JSON.stringify(updatedData));
    history.push("/eligibility-question-two");
  };

  const handleIconClick = (entryId) => {
    const entries = JSON.parse(localStorage.getItem("ayaAppEntries") || "[]");

    const getEntryById = (id) => entries.find((entry) => entry.sys.id === id);
    const getField = (entry, field, locale) =>
      entry?.fields?.[field]?.[locale] || entry?.fields?.[field]?.["en"] || "";

    const popupEntry = getEntryById(entryId);
    if (popupEntry) {
      setPopupContent({
        icon: getField(popupEntry, "icon", appLanguage),
        title: getField(popupEntry, "title", appLanguage),
        paragraph: getField(popupEntry, "paragraph", appLanguage),
        buttonText: "OK",
      });
      setShowPopup(true);
    }
  };

  return (
        <>
            <TopNavBarNew backgroundColor="#E12541" breadcrumbColor="#fff" />
    <div className={styles.pageContainer}>
      <div className={styles.topSection}>
        <h1 className={styles.title}>{pageState.title}</h1>
        <p className={styles.stepNumber}>{pageState.stepNumber}</p>
      </div>
      <div className={styles.whiteCard}>
        <h2 className={styles.title2}>{pageState.title2}</h2>
        {pageState.options.map((option, index) => (
          <div key={index} className={styles.optionRow}>
            <div
              className={`${styles.choice} ${
                selectedChoices.includes(index) ? styles.choiceSelected : ""
              }`}
              onClick={() => handleChoiceClick(index)}
            >
              <span>{option}</span>
            </div>
            {(index === 1 || index === 3) && (
              <img
                src={questionmarkIcon}
                alt="info"
                className={styles.icon}
                onClick={(e) => {
                  e.stopPropagation();
                  handleIconClick(
                    index === 1
                      ? "52xMEQvI7ZveJaEX3P91qb" // First question mark entry ID
                      : "5WCrltgnxTm6YPalquQ330" // Second question mark entry ID
                  );
                }}
              />
            )}
          </div>
        ))}
        <button
          className={`${styles.continueButton} ${
            selectedChoices.length > 0 ? styles.continueButtonActive : ""
          }`}
          onClick={selectedChoices.length > 0 ? handleContinue : null}
        >
          {pageState.buttonText}
        </button>
      </div>

      {/* Popup */}
      <PopUpEligibility
        show={showPopup}
        icon={popupContent.icon}
        title={popupContent.title}
        paragraph={popupContent.paragraph}
        buttonText={popupContent.buttonText}
        onClose={() => setShowPopup(false)}
      />

<div className={styles.bottomSpace}></div>
<BottomNavBarNew appLanguage={appLanguage}/>
    </div>
    </>
  );
}